/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.31",
    versionName: "0.2.0-nightly.2025.8.31",
    versionChannel: "nightly",
    buildDate: "2025-08-31T00:09:48.070Z",
    commitHash: "959d9d8fcb3438f01a1e11aa7735621e526f9a3a",
};
